import "../assets/index-f5162bbd.css";
import L from "./NcActions.mjs";
import y from "./NcActionButton.mjs";
import B from "./NcActionRouter.mjs";
import O from "./NcActionLink.mjs";
import w from "./NcBreadcrumb.mjs";
import m from "vue";
import { subscribe as R, unsubscribe as W } from "@nextcloud/event-bus";
import { n as g } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
import z from "debounce";
import { Fragment as D } from "vue-frag";
/**
 * @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const b = (t, e, s) => {
  if (t !== void 0)
    for (let n = t.length - 1; n >= 0; n--) {
      const a = t[n], r = !a.componentOptions && a.tag && e.indexOf(a.tag) === -1, i = !!a.componentOptions && typeof a.componentOptions.tag == "string", c = i && e.indexOf(a.componentOptions.tag) === -1;
      (r || !i || c) && ((r || c) && m.util.warn(`${r ? a.tag : a.componentOptions.tag} is not allowed inside the ${s.$options.name} component`, s), t.splice(n, 1));
    }
}, I = {
  name: "FolderIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var N = function() {
  var e = this, s = e._self._c;
  return s("span", e._b({ staticClass: "material-design-icon folder-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(n) {
    return e.$emit("click", n);
  } } }, "span", e.$attrs, !1), [s("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [s("path", { attrs: { d: "M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z" } }, [e.title ? s("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, C = [], A = /* @__PURE__ */ g(
  I,
  N,
  C,
  !1,
  null,
  null,
  null,
  null
);
const E = A.exports;
const o = "vue-crumb", x = {
  name: "NcBreadcrumbs",
  components: {
    NcActions: L,
    NcActionButton: y,
    NcActionRouter: B,
    NcActionLink: O,
    NcBreadcrumb: w,
    IconFolder: E
  },
  props: {
    /**
     * Set a css icon-class for the icon of the root breadcrumb to be used.
     */
    rootIcon: {
      type: String,
      default: "icon-home"
    },
    /**
     * Set the aria-label of the nav element.
     */
    ariaLabel: {
      type: String,
      default: null
    }
  },
  emits: ["dropped"],
  data() {
    return {
      /**
       * Array to track the hidden breadcrumbs by their index.
       * Comparing two crumbs somehow does not work, so we use the indices.
       */
      hiddenIndices: [],
      /**
       * This is the props of the middle Action menu
       * that show the ellipsised breadcrumbs
       */
      menuBreadcrumbProps: {
        // Don't show a name for this breadcrumb, only the Actions menu
        name: "",
        forceMenu: !0,
        // Don't allow dropping directly on the actions breadcrumb
        disableDrop: !0,
        // Is the menu open or not
        open: !1
      },
      breadcrumbsRefs: {}
    };
  },
  beforeMount() {
    b(this.$slots.default, ["NcBreadcrumb"], this);
  },
  beforeUpdate() {
    b(this.$slots.default, ["NcBreadcrumb"], this);
  },
  created() {
    window.addEventListener("resize", z(() => {
      this.handleWindowResize();
    }, 100)), R("navigation-toggled", this.delayedResize);
  },
  mounted() {
    this.handleWindowResize();
  },
  updated() {
    this.delayedResize(), this.$nextTick(() => {
      this.hideCrumbs();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize), W("navigation-toggled", this.delayedResize);
  },
  methods: {
    /**
     * Close the actions menu
     *
     * @param {object} e The event
     */
    closeActions(t) {
      this.$refs.actionsBreadcrumb.$el.contains(t.relatedTarget) || (this.menuBreadcrumbProps.open = !1);
    },
    /**
     * Call the resize function after a delay
     */
    async delayedResize() {
      await this.$nextTick(), this.handleWindowResize();
    },
    /**
     * Check the width of the breadcrumb and hide breadcrumbs
     * if we overflow otherwise.
     */
    handleWindowResize() {
      var l;
      if (!this.$refs.container)
        return;
      const t = Object.values(this.breadcrumbsRefs), e = t.length, s = [], n = this.$refs.container.offsetWidth;
      let a = this.getTotalWidth(t);
      this.$refs.breadcrumb__actions && (a += this.$refs.breadcrumb__actions.offsetWidth);
      let r = a - n;
      r += r > 0 ? 64 : 0;
      let i = 0;
      const c = Math.floor(e / 2);
      for (; r > 0 && i < e - 2; ) {
        const d = c + (i % 2 ? i + 1 : i) / 2 * Math.pow(-1, i + e % 2);
        r -= this.getWidth((l = t[d]) == null ? void 0 : l.elm), s.push(d), i++;
      }
      this.arraysEqual(this.hiddenIndices, s.sort((d, u) => d - u)) || (this.hiddenIndices = s);
    },
    /**
     * Checks if two arrays are equal.
     * Only works for primitive arrays, but that's enough here.
     *
     * @param {Array} a The first array
     * @param {Array} b The second array
     * @return {boolean} Wether the arrays are equal
     */
    arraysEqual(t, e) {
      if (t.length !== e.length)
        return !1;
      if (t === e)
        return !0;
      if (t === null || e === null)
        return !1;
      for (let s = 0; s < t.length; ++s)
        if (t[s] !== e[s])
          return !1;
      return !0;
    },
    /**
     * Calculates the total width of all breadcrumbs
     *
     * @param {Array} breadcrumbs All breadcrumbs
     * @return {number} The total width
     */
    getTotalWidth(t) {
      return t.reduce((e, s, n) => e + this.getWidth(s == null ? void 0 : s.elm), 0);
    },
    /**
     * Calculates the width of the provided element
     *
     * @param {object} el The element
     * @return {number} The width
     */
    getWidth(t) {
      if (!(t != null && t.classList))
        return 0;
      const e = t.classList.contains(`${o}--hidden`);
      t.style.minWidth = "auto", t.classList.remove(`${o}--hidden`);
      const s = t.offsetWidth;
      return e && t.classList.add(`${o}--hidden`), t.style.minWidth = "", s;
    },
    /**
     * Prevents the default of a provided event
     *
     * @param {object} e The event
     * @return {boolean}
     */
    preventDefault(t) {
      return t.preventDefault && t.preventDefault(), !1;
    },
    /**
     * Handles the drag start.
     * Prevents a breadcrumb from being draggable.
     *
     * @param {object} e The event
     * @return {boolean}
     */
    dragStart(t) {
      return this.preventDefault(t);
    },
    /**
     * Handles when something is dropped on the breadcrumb.
     *
     * @param {object} e The drop event
     * @param {string} path The path of the breadcrumb
     * @param {boolean} disabled Whether dropping is disabled for this breadcrumb
     * @return {boolean}
     */
    dropped(t, e, s) {
      return s || this.$emit("dropped", t, e), this.menuBreadcrumbProps.open = !1, document.querySelectorAll(`.${o}`).forEach((a) => {
        a.classList.remove(`${o}--hovered`);
      }), this.preventDefault(t);
    },
    /**
     * Handles the drag over event
     *
     * @param {object} e The drag over event
     * @return {boolean}
     */
    dragOver(t) {
      return this.preventDefault(t);
    },
    /**
     * Handles the drag enter event
     *
     * @param {object} e The drag over event
     * @param {boolean} disabled Whether dropping is disabled for this breadcrumb
     */
    dragEnter(t, e) {
      if (!e && t.target.closest) {
        const s = t.target.closest(`.${o}`);
        s.classList && s.classList.contains(o) && (document.querySelectorAll(`.${o}`).forEach((a) => {
          a.classList.remove(`${o}--hovered`);
        }), s.classList.add(`${o}--hovered`));
      }
    },
    /**
     * Handles the drag leave event
     *
     * @param {object} e The drag leave event
     * @param {boolean} disabled Whether dropping is disabled for this breadcrumb
     */
    dragLeave(t, e) {
      if (!e && !t.target.contains(t.relatedTarget) && t.target.closest) {
        const s = t.target.closest(`.${o}`);
        if (s.contains(t.relatedTarget))
          return;
        s.classList && s.classList.contains(o) && s.classList.remove(`${o}--hovered`);
      }
    },
    /**
     * Check for each crumb if we have to hide it and
     * add it to the array of all crumbs.
     */
    hideCrumbs() {
      Object.values(this.breadcrumbsRefs).forEach((e, s) => {
        var n;
        (n = e == null ? void 0 : e.elm) != null && n.classList && (this.hiddenIndices.includes(s) ? e.elm.classList.add(`${o}--hidden`) : e.elm.classList.remove(`${o}--hidden`));
      });
    },
    isBreadcrumb(t) {
      var e;
      return (((e = t == null ? void 0 : t.componentOptions) == null ? void 0 : e.tag) || (t == null ? void 0 : t.tag) || "").includes("NcBreadcrumb");
    }
  },
  /**
   * The render function to display the component
   *
   * @param {Function} h The function to create VNodes
   * @return {object|undefined} The created VNode
   */
  render(t) {
    const e = [];
    if (this.$slots.default.forEach((r) => {
      var i, c;
      if (this.isBreadcrumb(r)) {
        e.push(r);
        return;
      }
      (r == null ? void 0 : r.type) === D && ((c = (i = r == null ? void 0 : r.children) == null ? void 0 : i.forEach) == null || c.call(i, (l) => {
        this.isBreadcrumb(l) && e.push(l);
      }));
    }), e.length === 0)
      return;
    m.set(e[0].componentOptions.propsData, "icon", this.rootIcon), m.set(e[0].componentOptions.propsData, "ref", "breadcrumbs");
    const s = {};
    e.forEach((r, i) => {
      m.set(r, "ref", `crumb-${i}`), s[i] = r;
    });
    let n = [];
    if (!this.hiddenIndices.length)
      n = e;
    else {
      n = e.slice(0, Math.round(e.length / 2)), n.push(
        t("NcBreadcrumb", {
          class: "dropdown",
          props: this.menuBreadcrumbProps,
          attrs: {
            // Hide the dropdown menu from screen-readers,
            // since the crumbs in the menu are still in the list.
            "aria-hidden": !0
          },
          // Add a ref to the Actions menu
          ref: "actionsBreadcrumb",
          key: "actions-breadcrumb-1",
          // Add handlers so the Actions menu opens on hover
          nativeOn: {
            dragstart: this.dragStart,
            dragenter: () => {
              this.menuBreadcrumbProps.open = !0;
            },
            dragleave: this.closeActions
          },
          on: {
            // Make sure we keep the same open state
            // as the Actions component
            "update:open": (i) => {
              this.menuBreadcrumbProps.open = i;
            }
          }
          // Add all hidden breadcrumbs as ActionRouter or ActionLink
        }, this.hiddenIndices.map((i) => {
          const c = e[i], l = c.componentOptions.propsData.to, d = c.componentOptions.propsData.href, u = c.componentOptions.propsData.disableDrop, _ = c.componentOptions.propsData.title, $ = c.componentOptions.propsData.name;
          let h = "NcActionButton", f = "";
          d && (h = "NcActionLink", f = d), l && (h = "NcActionRouter", f = l);
          const v = t("IconFolder", {
            props: {
              size: 20
            },
            slot: "icon"
          });
          return t(
            h,
            {
              class: o,
              props: {
                href: d || null,
                title: _,
                to: l || null
              },
              // Prevent the breadcrumbs from being draggable
              attrs: {
                draggable: !1
              },
              on: {
                ...c.componentOptions.listeners
              },
              // Add the drag and drop handlers
              nativeOn: {
                dragstart: this.dragStart,
                drop: (p) => this.dropped(p, f, u),
                dragover: this.dragOver,
                dragenter: (p) => this.dragEnter(p, u),
                dragleave: (p) => this.dragLeave(p, u)
              }
            },
            [v, $]
          );
        }))
      );
      const r = e.slice(Math.round(e.length / 2));
      n = n.concat(r);
    }
    const a = [t("nav", { attrs: { "aria-label": this.ariaLabel } }, [t("ul", { class: "breadcrumb__crumbs" }, [n])])];
    return this.$slots.actions && a.push(t("div", { class: "breadcrumb__actions", ref: "breadcrumb__actions" }, this.$slots.actions)), this.breadcrumbsRefs = s, t("div", { class: ["breadcrumb", { "breadcrumb--collapsed": this.hiddenIndices.length === e.length - 2 }], ref: "container" }, a);
  }
}, S = null, k = null;
var F = /* @__PURE__ */ g(
  x,
  S,
  k,
  !1,
  null,
  "50e21eb2",
  null,
  null
);
const K = F.exports;
export {
  K as default
};
